// extracted by mini-css-extract-plugin
module.exports = {"boddy":"Reciept_boddy__1qWuO","page":"Reciept_page__1HUx6","priceBox":"Reciept_priceBox__XvVmZ"};